//!#system	

import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from '@/store';

Vue.use(Router);

function guard(to, from, next){
    // TODO: store where they wanted to go
    // So that if `isAuthenticated` becomes yes (like, after a F5)
    // you can take them there
    const noGoToRoutes = ['/ui/sign-out', '/ui/sign-in'];

    const kickOut = function(next) {
      let currentRoute = window.location.pathname;
      if (noGoToRoutes.includes(currentRoute)) return next('/sign-in');
      if (window.location.search) currentRoute += window.location.search;
      if (currentRoute) {
        return window.location.href = '/ui/sign-in?goto=' + encodeURIComponent(currentRoute);
      } else {
        return next('/sign-in');
      }
    };

    if(store.state.authentication.isAuthenticated) {
        next(); // allow to enter route
    } else {
        store.dispatch('authentication/userLoad', {
          callback: (err) => {
            if (err) {
              return kickOut(next);
            }
            return next(); // allow them to go to the route
          } 
        });
    }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      beforeEnter: guard,
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue')
    },
    {
      beforeEnter: guard,
      path: '/app/reports',
      name: 'reports',
      component: () => import('./views/Reports.vue'),
      children: [
        {
          path: 'report/:id',
          name: 'reports',
          component: () => import('./views/ReportRunner.vue')
        }
        ]
    },
    {
      beforeEnter: guard,
      path: '/app/settings',
      name: 'settings',
      component: () => import('./views/Settings.vue'),
      children: [
        {
          path: '',
          name: 'settings',
          component: () => import('./views/SettingsDefault.vue')
        },
        {
          path: 'comms/email-templates',
          name: 'emailTemplates',
          component: () => import( /* webpackChunkName: "comms_emailTemplate" */ './views/app/comms/EmailTemplateList.vue')
        },
        {
          path: 'comms/email-templates/detail/:id',
          name: 'emailTemplate-detail',
          component: () => import( /* webpackChunkName: "comms_emailTemplate" */ './views/app/comms/EmailTemplateDetail.vue')
        },
        {
          path: 'comms/queued-emails',
          name: 'queuedEmails',
          component: () => import( /* webpackChunkName: "comms_queuedEmail" */ './views/app/comms/QueuedEmailList.vue')
        },
        {
          path: 'comms/queued-emails/detail/:id',
          name: 'queuedEmail-detail',
          component: () => import( /* webpackChunkName: "comms_queuedEmail" */ './views/app/comms/QueuedEmailDetail.vue')
        },
        {
          path: 'system/queues',
          name: 'queues',
          component: () => import( /* webpackChunkName: "system_queue" */ './views/app/system/QueueList.vue')
        },
        {
          path: 'system/queues/detail/:id',
          name: 'queue-detail',
          component: () => import( /* webpackChunkName: "system_queue" */ './views/app/system/QueueDetail.vue')
        },
        {
          path: 'uac/groups',
          name: 'groups',
          component: () => import( /* webpackChunkName: "uac_group" */ './views/app/uac/GroupList.vue')
        },
        {
          path: 'uac/groups/detail/:id',
          name: 'group-detail',
          component: () => import( /* webpackChunkName: "uac_group" */ './views/app/uac/GroupDetail.vue')
        },
        {
          path: 'uac/invites',
          name: 'invites',
          component: () => import( /* webpackChunkName: "uac_invite" */ './views/app/uac/InviteList.vue')
        },
        {
          path: 'uac/invites/detail/:id',
          name: 'invite-detail',
          component: () => import( /* webpackChunkName: "uac_invite" */ './views/app/uac/InviteDetail.vue')
        },
        {
          path: 'uac/users',
          name: 'users',
          component: () => import( /* webpackChunkName: "uac_user" */ './views/app/uac/UserList.vue')
        },
        {
          path: 'uac/users/detail/:id',
          name: 'user-detail',
          component: () => import( /* webpackChunkName: "uac_user" */ './views/app/uac/UserDetail.vue')
        },
        {
          path: 'dist/locations',
          name: 'locations',
          component: () => import( /* webpackChunkName: "dist_location" */ './views/app/dist/LocationList.vue')
        },
        {
          path: 'dist/locations/detail/:id',
          name: 'location-detail',
          component: () => import( /* webpackChunkName: "dist_location" */ './views/app/dist/LocationDetail.vue')
        },
        {
          path: 'people/pre-maps',
          name: 'preMaps',
          component: () => import( /* webpackChunkName: "people_preMap" */ './views/app/people/PreMapList.vue')
        },
        {
          path: 'people/pre-maps/detail/:id',
          name: 'preMap-detail',
          component: () => import( /* webpackChunkName: "people_preMap" */ './views/app/people/PreMapDetail.vue')
        },
        {
          path: 'people/schools',
          name: 'schools',
          component: () => import( /* webpackChunkName: "people_school" */ './views/app/people/SchoolList.vue')
        },
        {
          path: 'people/schools/detail/:id',
          name: 'school-detail',
          component: () => import( /* webpackChunkName: "people_school" */ './views/app/people/SchoolDetail.vue')
        }
      ]
    },
    {
      beforeEnter: guard,
      path: '/app/admin',
      name: 'admin',
      component: () => import('./views/Admin.vue'),
      children: [
        {
          path: '',
          name: 'admin',
          component: () => import('./views/AdminDefault.vue')
        },
        {
          path: 'bpa/automated-tasks',
          name: 'automatedTasks',
          component: () => import( /* webpackChunkName: "bpa_automatedTask" */ './views/app/bpa/AutomatedTaskList.vue')
        },
        {
          path: 'bpa/automated-tasks/detail/:id',
          name: 'automatedTask-detail',
          component: () => import( /* webpackChunkName: "bpa_automatedTask" */ './views/app/bpa/AutomatedTaskDetail.vue')
        },
        {
          path: 'bpa/data-files',
          name: 'dataFiles',
          component: () => import( /* webpackChunkName: "bpa_dataFile" */ './views/app/bpa/DataFileList.vue')
        },
        {
          path: 'bpa/data-files/detail/:id',
          name: 'dataFile-detail',
          component: () => import( /* webpackChunkName: "bpa_dataFile" */ './views/app/bpa/DataFileDetail.vue')
        },
        {
          path: 'bpa/data-transformation-templates',
          name: 'dataTransformationTemplates',
          component: () => import( /* webpackChunkName: "bpa_dataTransformationTemplate" */ './views/app/bpa/DataTransformationTemplateList.vue')
        },
        {
          path: 'bpa/data-transformation-templates/detail/:id',
          name: 'dataTransformationTemplate-detail',
          component: () => import( /* webpackChunkName: "bpa_dataTransformationTemplate" */ './views/app/bpa/DataTransformationTemplateDetail.vue')
        },
        {
          path: 'bpa/excel-export-templates',
          name: 'excelExportTemplates',
          component: () => import( /* webpackChunkName: "bpa_excelExportTemplate" */ './views/app/bpa/ExcelExportTemplateList.vue')
        },
        {
          path: 'bpa/excel-export-templates/detail/:id',
          name: 'excelExportTemplate-detail',
          component: () => import( /* webpackChunkName: "bpa_excelExportTemplate" */ './views/app/bpa/ExcelExportTemplateDetail.vue')
        },
        {
          path: 'bpa/file-transfer-locations',
          name: 'fileTransferLocations',
          component: () => import( /* webpackChunkName: "bpa_fileTransferLocation" */ './views/app/bpa/FileTransferLocationList.vue')
        },
        {
          path: 'bpa/file-transfer-locations/detail/:id',
          name: 'fileTransferLocation-detail',
          component: () => import( /* webpackChunkName: "bpa_fileTransferLocation" */ './views/app/bpa/FileTransferLocationDetail.vue')
        },
        {
          path: 'bpa/import-mappings',
          name: 'importMappings',
          component: () => import( /* webpackChunkName: "bpa_importMapping" */ './views/app/bpa/ImportMappingList.vue')
        },
        {
          path: 'bpa/import-mappings/detail/:id',
          name: 'importMapping-detail',
          component: () => import( /* webpackChunkName: "bpa_importMapping" */ './views/app/bpa/ImportMappingDetail.vue')
        },
        {
          path: 'bpa/ingress-transformation-templates',
          name: 'ingressTransformationTemplates',
          component: () => import( /* webpackChunkName: "bpa_ingressTransformationTemplate" */ './views/app/bpa/IngressTransformationTemplateList.vue')
        },
        {
          path: 'bpa/ingress-transformation-templates/detail/:id',
          name: 'ingressTransformationTemplate-detail',
          component: () => import( /* webpackChunkName: "bpa_ingressTransformationTemplate" */ './views/app/bpa/IngressTransformationTemplateDetail.vue')
        },
        {
          path: 'bpa/task-results',
          name: 'taskResults',
          component: () => import( /* webpackChunkName: "bpa_taskResult" */ './views/app/bpa/TaskResultList.vue')
        },
        {
          path: 'bpa/task-results/detail/:id',
          name: 'taskResult-detail',
          component: () => import( /* webpackChunkName: "bpa_taskResult" */ './views/app/bpa/TaskResultDetail.vue')
        },
        {
          path: 'bpa/web-services',
          name: 'webServices',
          component: () => import( /* webpackChunkName: "bpa_webService" */ './views/app/bpa/WebServiceList.vue')
        },
        {
          path: 'bpa/web-services/detail/:id',
          name: 'webService-detail',
          component: () => import( /* webpackChunkName: "bpa_webService" */ './views/app/bpa/WebServiceDetail.vue')
        },
        {
          path: 'comms/email-senders',
          name: 'emailSenders',
          component: () => import( /* webpackChunkName: "comms_emailSender" */ './views/app/comms/EmailSenderList.vue')
        },
        {
          path: 'comms/email-senders/detail/:id',
          name: 'emailSender-detail',
          component: () => import( /* webpackChunkName: "comms_emailSender" */ './views/app/comms/EmailSenderDetail.vue')
        },
        {
          path: 'comms/smtp-connections',
          name: 'smtpConnections',
          component: () => import( /* webpackChunkName: "comms_smtpConnection" */ './views/app/comms/SmtpConnectionList.vue')
        },
        {
          path: 'comms/smtp-connections/detail/:id',
          name: 'smtpConnection-detail',
          component: () => import( /* webpackChunkName: "comms_smtpConnection" */ './views/app/comms/SmtpConnectionDetail.vue')
        },
        {
          path: 'custom/custom-field-configs',
          name: 'customFieldConfigs',
          component: () => import( /* webpackChunkName: "custom_customFieldConfig" */ './views/app/custom/CustomFieldConfigList.vue')
        },
        {
          path: 'custom/custom-field-configs/detail/:id',
          name: 'customFieldConfig-detail',
          component: () => import( /* webpackChunkName: "custom_customFieldConfig" */ './views/app/custom/CustomFieldConfigDetail.vue')
        },
        {
          path: 'system/application-files',
          name: 'applicationFiles',
          component: () => import( /* webpackChunkName: "system_applicationFile" */ './views/app/system/ApplicationFileList.vue')
        },
        {
          path: 'system/application-files/detail/:id',
          name: 'applicationFile-detail',
          component: () => import( /* webpackChunkName: "system_applicationFile" */ './views/app/system/ApplicationFileDetail.vue')
        },
        {
          path: 'system/dashboards',
          name: 'dashboards',
          component: () => import( /* webpackChunkName: "system_dashboard" */ './views/app/system/DashboardList.vue')
        },
        {
          path: 'system/dashboards/detail/:id',
          name: 'dashboard-detail',
          component: () => import( /* webpackChunkName: "system_dashboard" */ './views/app/system/DashboardDetail.vue')
        },
        {
          path: 'system/dashboard-modules',
          name: 'dashboardModules',
          component: () => import( /* webpackChunkName: "system_dashboardModule" */ './views/app/system/DashboardModuleList.vue')
        },
        {
          path: 'system/dashboard-modules/detail/:id',
          name: 'dashboardModule-detail',
          component: () => import( /* webpackChunkName: "system_dashboardModule" */ './views/app/system/DashboardModuleDetail.vue')
        },
        {
          path: 'system/data-retention-policies',
          name: 'dataRetentionPolicies',
          component: () => import( /* webpackChunkName: "system_dataRetentionPolicy" */ './views/app/system/DataRetentionPolicyList.vue')
        },
        {
          path: 'system/data-retention-policies/detail/:id',
          name: 'dataRetentionPolicy-detail',
          component: () => import( /* webpackChunkName: "system_dataRetentionPolicy" */ './views/app/system/DataRetentionPolicyDetail.vue')
        },
        {
          path: 'system/external-links',
          name: 'externalLinks',
          component: () => import( /* webpackChunkName: "system_externalLink" */ './views/app/system/ExternalLinkList.vue')
        },
        {
          path: 'system/external-links/detail/:id',
          name: 'externalLink-detail',
          component: () => import( /* webpackChunkName: "system_externalLink" */ './views/app/system/ExternalLinkDetail.vue')
        },
        {
          path: 'system/logging-options',
          name: 'loggingOptions',
          component: () => import( /* webpackChunkName: "system_loggingOption" */ './views/app/system/LoggingOptionList.vue')
        },
        {
          path: 'system/logging-options/detail/:id',
          name: 'loggingOption-detail',
          component: () => import( /* webpackChunkName: "system_loggingOption" */ './views/app/system/LoggingOptionDetail.vue')
        },
        {
          path: 'system/logos',
          name: 'logos',
          component: () => import( /* webpackChunkName: "system_logo" */ './views/app/system/LogoList.vue')
        },
        {
          path: 'system/logos/detail/:id',
          name: 'logo-detail',
          component: () => import( /* webpackChunkName: "system_logo" */ './views/app/system/LogoDetail.vue')
        },
        {
          path: 'system/rules',
          name: 'rules',
          component: () => import( /* webpackChunkName: "system_rule" */ './views/app/system/RuleList.vue')
        },
        {
          path: 'system/rules/detail/:id',
          name: 'rule-detail',
          component: () => import( /* webpackChunkName: "system_rule" */ './views/app/system/RuleDetail.vue')
        },
        {
          path: 'system/storage-connections',
          name: 'storageConnections',
          component: () => import( /* webpackChunkName: "system_storageConnection" */ './views/app/system/StorageConnectionList.vue')
        },
        {
          path: 'system/storage-connections/detail/:id',
          name: 'storageConnection-detail',
          component: () => import( /* webpackChunkName: "system_storageConnection" */ './views/app/system/StorageConnectionDetail.vue')
        },
        {
          path: 'system/sys-logs',
          name: 'sysLogs',
          component: () => import( /* webpackChunkName: "system_sysLog" */ './views/app/system/SysLogList.vue')
        },
        {
          path: 'system/sys-logs/detail/:id',
          name: 'sysLog-detail',
          component: () => import( /* webpackChunkName: "system_sysLog" */ './views/app/system/SysLogDetail.vue')
        },
        {
          path: 'uac/registrations',
          name: 'registrations',
          component: () => import( /* webpackChunkName: "uac_registration" */ './views/app/uac/RegistrationList.vue')
        },
        {
          path: 'uac/registrations/detail/:id',
          name: 'registration-detail',
          component: () => import( /* webpackChunkName: "uac_registration" */ './views/app/uac/RegistrationDetail.vue')
        },
        {
          path: 'uac/sign-ins',
          name: 'signIns',
          component: () => import( /* webpackChunkName: "uac_signIn" */ './views/app/uac/SignInList.vue')
        },
        {
          path: 'uac/sign-ins/detail/:id',
          name: 'signIn-detail',
          component: () => import( /* webpackChunkName: "uac_signIn" */ './views/app/uac/SignInDetail.vue')
        }
      ]
    },
    {
      beforeEnter: guard,
      path: '/app/browser',
      name: 'browser',
      component: () => import('./views/Browser.vue'),
      children: [
        {
          path: '',
          name: 'data-browser',
          component: () => import('./views/BrowserDefault.vue')
        },
        {
          path: 'bpa/automated-task-gates',
          name: 'automatedTaskGates',
          component: () => import( /* webpackChunkName: "bpa_automatedTaskGate" */ './views/app/bpa/AutomatedTaskGateList.vue')
        },
        {
          path: 'bpa/automated-task-gates/detail/:id',
          name: 'automatedTaskGate-detail',
          component: () => import( /* webpackChunkName: "bpa_automatedTaskGate" */ './views/app/bpa/AutomatedTaskGateDetail.vue')
        },
        {
          path: 'bpa/leaky-jugs',
          name: 'leakyJugs',
          component: () => import( /* webpackChunkName: "bpa_leakyJug" */ './views/app/bpa/LeakyJugList.vue')
        },
        {
          path: 'bpa/leaky-jugs/detail/:id',
          name: 'leakyJug-detail',
          component: () => import( /* webpackChunkName: "bpa_leakyJug" */ './views/app/bpa/LeakyJugDetail.vue')
        },
        {
          path: 'bpa/webhooks',
          name: 'webhooks',
          component: () => import( /* webpackChunkName: "bpa_webhook" */ './views/app/bpa/WebhookList.vue')
        },
        {
          path: 'bpa/webhooks/detail/:id',
          name: 'webhook-detail',
          component: () => import( /* webpackChunkName: "bpa_webhook" */ './views/app/bpa/WebhookDetail.vue')
        },
        {
          path: 'comms/email-attachments',
          name: 'emailAttachments',
          component: () => import( /* webpackChunkName: "comms_emailAttachment" */ './views/app/comms/EmailAttachmentList.vue')
        },
        {
          path: 'comms/email-attachments/detail/:id',
          name: 'emailAttachment-detail',
          component: () => import( /* webpackChunkName: "comms_emailAttachment" */ './views/app/comms/EmailAttachmentDetail.vue')
        },
        {
          path: 'comms/email-statuses',
          name: 'emailStatuses',
          component: () => import( /* webpackChunkName: "comms_emailStatus" */ './views/app/comms/EmailStatusList.vue')
        },
        {
          path: 'comms/email-statuses/detail/:id',
          name: 'emailStatus-detail',
          component: () => import( /* webpackChunkName: "comms_emailStatus" */ './views/app/comms/EmailStatusDetail.vue')
        },
        {
          path: 'reporting/report-definitions',
          name: 'reportDefinitions',
          component: () => import( /* webpackChunkName: "reporting_reportDefinition" */ './views/app/reporting/ReportDefinitionList.vue')
        },
        {
          path: 'reporting/report-definitions/detail/:id',
          name: 'reportDefinition-detail',
          component: () => import( /* webpackChunkName: "reporting_reportDefinition" */ './views/app/reporting/ReportDefinitionDetail.vue')
        },
        {
          path: 'system/dashboard-module-types',
          name: 'dashboardModuleTypes',
          component: () => import( /* webpackChunkName: "system_dashboardModuleType" */ './views/app/system/DashboardModuleTypeList.vue')
        },
        {
          path: 'system/dashboard-module-types/detail/:id',
          name: 'dashboardModuleType-detail',
          component: () => import( /* webpackChunkName: "system_dashboardModuleType" */ './views/app/system/DashboardModuleTypeDetail.vue')
        },
        {
          path: 'system/history-types',
          name: 'historyTypes',
          component: () => import( /* webpackChunkName: "system_historyType" */ './views/app/system/HistoryTypeList.vue')
        },
        {
          path: 'system/history-types/detail/:id',
          name: 'historyType-detail',
          component: () => import( /* webpackChunkName: "system_historyType" */ './views/app/system/HistoryTypeDetail.vue')
        },
        {
          path: 'system/linkers',
          name: 'linkers',
          component: () => import( /* webpackChunkName: "system_linker" */ './views/app/system/LinkerList.vue')
        },
        {
          path: 'system/linkers/detail/:id',
          name: 'linker-detail',
          component: () => import( /* webpackChunkName: "system_linker" */ './views/app/system/LinkerDetail.vue')
        },
        {
          path: 'system/recurrence-types',
          name: 'recurrenceTypes',
          component: () => import( /* webpackChunkName: "system_recurrenceType" */ './views/app/system/RecurrenceTypeList.vue')
        },
        {
          path: 'system/recurrence-types/detail/:id',
          name: 'recurrenceType-detail',
          component: () => import( /* webpackChunkName: "system_recurrenceType" */ './views/app/system/RecurrenceTypeDetail.vue')
        },
        {
          path: 'system/startup-controllers',
          name: 'startupControllers',
          component: () => import( /* webpackChunkName: "system_startupController" */ './views/app/system/StartupControllerList.vue')
        },
        {
          path: 'system/startup-controllers/detail/:id',
          name: 'startupController-detail',
          component: () => import( /* webpackChunkName: "system_startupController" */ './views/app/system/StartupControllerDetail.vue')
        },
        {
          path: 'system/storage-connection-types',
          name: 'storageConnectionTypes',
          component: () => import( /* webpackChunkName: "system_storageConnectionType" */ './views/app/system/StorageConnectionTypeList.vue')
        },
        {
          path: 'system/storage-connection-types/detail/:id',
          name: 'storageConnectionType-detail',
          component: () => import( /* webpackChunkName: "system_storageConnectionType" */ './views/app/system/StorageConnectionTypeDetail.vue')
        },
        {
          path: 'system/string-templates',
          name: 'stringTemplates',
          component: () => import( /* webpackChunkName: "system_stringTemplate" */ './views/app/system/StringTemplateList.vue')
        },
        {
          path: 'system/string-templates/detail/:id',
          name: 'stringTemplate-detail',
          component: () => import( /* webpackChunkName: "system_stringTemplate" */ './views/app/system/StringTemplateDetail.vue')
        },
        {
          path: 'system/subscriptions',
          name: 'subscriptions',
          component: () => import( /* webpackChunkName: "system_subscription" */ './views/app/system/SubscriptionList.vue')
        },
        {
          path: 'system/subscriptions/detail/:id',
          name: 'subscription-detail',
          component: () => import( /* webpackChunkName: "system_subscription" */ './views/app/system/SubscriptionDetail.vue')
        },
        {
          path: 'uac/user-avatars',
          name: 'userAvatars',
          component: () => import( /* webpackChunkName: "uac_userAvatar" */ './views/app/uac/UserAvatarList.vue')
        },
        {
          path: 'uac/user-avatars/detail/:id',
          name: 'userAvatar-detail',
          component: () => import( /* webpackChunkName: "uac_userAvatar" */ './views/app/uac/UserAvatarDetail.vue')
        },
        {
          path: 'uac/user-prefs',
          name: 'userPrefs',
          component: () => import( /* webpackChunkName: "uac_userPref" */ './views/app/uac/UserPrefList.vue')
        },
        {
          path: 'uac/user-prefs/detail/:id',
          name: 'userPref-detail',
          component: () => import( /* webpackChunkName: "uac_userPref" */ './views/app/uac/UserPrefDetail.vue')
        },
        {
          path: 'uac/user-types',
          name: 'userTypes',
          component: () => import( /* webpackChunkName: "uac_userType" */ './views/app/uac/UserTypeList.vue')
        },
        {
          path: 'uac/user-types/detail/:id',
          name: 'userType-detail',
          component: () => import( /* webpackChunkName: "uac_userType" */ './views/app/uac/UserTypeDetail.vue')
        }
      ]
    },
    {
      path: '/sign-in',
      name: 'signin',
      component: () => import('./views/Signin.vue')
    },
    {
      beforeEnter: guard,
      path: '/sign-out',
      name: 'signout',
      component: () => import('./views/Signout.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/activate',
      name: 'activate',
      component: () => import('./views/Activate.vue')
    },
    {
      path: '/forgot-my-password',
      name: 'forgot-my-password',
      component: () => import('./views/ForgotMyPassword.vue')
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: () => import('./views/PasswordReset.vue')
    },
    // app navigation
    {
      beforeEnter: guard,
      path:'/app/uac/users',
      name: 'uac_users-list',
      component: () => import( /* webpackChunkName: "uac_users" */ './views/app/uac/UserList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/users/detail/:id',
      name: 'uac_users-detail',
      component: () => import( /* webpackChunkName: "uac_users" */ './views/app/uac/UserDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/automated-tasks',
      name: 'bpa_automated-tasks-list',
      component: () => import( /* webpackChunkName: "bpa_automated-tasks" */ './views/app/bpa/AutomatedTaskList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/automated-tasks/detail/:id',
      name: 'bpa_automated-tasks-detail',
      component: () => import( /* webpackChunkName: "bpa_automated-tasks" */ './views/app/bpa/AutomatedTaskDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/automated-task-gates',
      name: 'bpa_automated-task-gates-list',
      component: () => import( /* webpackChunkName: "bpa_automated-task-gates" */ './views/app/bpa/AutomatedTaskGateList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/automated-task-gates/detail/:id',
      name: 'bpa_automated-task-gates-detail',
      component: () => import( /* webpackChunkName: "bpa_automated-task-gates" */ './views/app/bpa/AutomatedTaskGateDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/data-files',
      name: 'bpa_data-files-list',
      component: () => import( /* webpackChunkName: "bpa_data-files" */ './views/app/bpa/DataFileList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/data-files/detail/:id',
      name: 'bpa_data-files-detail',
      component: () => import( /* webpackChunkName: "bpa_data-files" */ './views/app/bpa/DataFileDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/data-transformation-templates',
      name: 'bpa_data-transformation-templates-list',
      component: () => import( /* webpackChunkName: "bpa_data-transformation-templates" */ './views/app/bpa/DataTransformationTemplateList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/data-transformation-templates/detail/:id',
      name: 'bpa_data-transformation-templates-detail',
      component: () => import( /* webpackChunkName: "bpa_data-transformation-templates" */ './views/app/bpa/DataTransformationTemplateDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/excel-export-templates',
      name: 'bpa_excel-export-templates-list',
      component: () => import( /* webpackChunkName: "bpa_excel-export-templates" */ './views/app/bpa/ExcelExportTemplateList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/excel-export-templates/detail/:id',
      name: 'bpa_excel-export-templates-detail',
      component: () => import( /* webpackChunkName: "bpa_excel-export-templates" */ './views/app/bpa/ExcelExportTemplateDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/file-transfer-locations',
      name: 'bpa_file-transfer-locations-list',
      component: () => import( /* webpackChunkName: "bpa_file-transfer-locations" */ './views/app/bpa/FileTransferLocationList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/file-transfer-locations/detail/:id',
      name: 'bpa_file-transfer-locations-detail',
      component: () => import( /* webpackChunkName: "bpa_file-transfer-locations" */ './views/app/bpa/FileTransferLocationDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/import-mappings',
      name: 'bpa_import-mappings-list',
      component: () => import( /* webpackChunkName: "bpa_import-mappings" */ './views/app/bpa/ImportMappingList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/import-mappings/detail/:id',
      name: 'bpa_import-mappings-detail',
      component: () => import( /* webpackChunkName: "bpa_import-mappings" */ './views/app/bpa/ImportMappingDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/ingress-transformation-templates',
      name: 'bpa_ingress-transformation-templates-list',
      component: () => import( /* webpackChunkName: "bpa_ingress-transformation-templates" */ './views/app/bpa/IngressTransformationTemplateList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/ingress-transformation-templates/detail/:id',
      name: 'bpa_ingress-transformation-templates-detail',
      component: () => import( /* webpackChunkName: "bpa_ingress-transformation-templates" */ './views/app/bpa/IngressTransformationTemplateDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/leaky-jugs',
      name: 'bpa_leaky-jugs-list',
      component: () => import( /* webpackChunkName: "bpa_leaky-jugs" */ './views/app/bpa/LeakyJugList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/leaky-jugs/detail/:id',
      name: 'bpa_leaky-jugs-detail',
      component: () => import( /* webpackChunkName: "bpa_leaky-jugs" */ './views/app/bpa/LeakyJugDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/task-results',
      name: 'bpa_task-results-list',
      component: () => import( /* webpackChunkName: "bpa_task-results" */ './views/app/bpa/TaskResultList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/task-results/detail/:id',
      name: 'bpa_task-results-detail',
      component: () => import( /* webpackChunkName: "bpa_task-results" */ './views/app/bpa/TaskResultDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/webhooks',
      name: 'bpa_webhooks-list',
      component: () => import( /* webpackChunkName: "bpa_webhooks" */ './views/app/bpa/WebhookList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/webhooks/detail/:id',
      name: 'bpa_webhooks-detail',
      component: () => import( /* webpackChunkName: "bpa_webhooks" */ './views/app/bpa/WebhookDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/web-services',
      name: 'bpa_web-services-list',
      component: () => import( /* webpackChunkName: "bpa_web-services" */ './views/app/bpa/WebServiceList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/bpa/web-services/detail/:id',
      name: 'bpa_web-services-detail',
      component: () => import( /* webpackChunkName: "bpa_web-services" */ './views/app/bpa/WebServiceDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-attachments',
      name: 'comms_email-attachments-list',
      component: () => import( /* webpackChunkName: "comms_email-attachments" */ './views/app/comms/EmailAttachmentList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-attachments/detail/:id',
      name: 'comms_email-attachments-detail',
      component: () => import( /* webpackChunkName: "comms_email-attachments" */ './views/app/comms/EmailAttachmentDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-senders',
      name: 'comms_email-senders-list',
      component: () => import( /* webpackChunkName: "comms_email-senders" */ './views/app/comms/EmailSenderList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-senders/detail/:id',
      name: 'comms_email-senders-detail',
      component: () => import( /* webpackChunkName: "comms_email-senders" */ './views/app/comms/EmailSenderDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-statuses',
      name: 'comms_email-statuses-list',
      component: () => import( /* webpackChunkName: "comms_email-statuses" */ './views/app/comms/EmailStatusList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-statuses/detail/:id',
      name: 'comms_email-statuses-detail',
      component: () => import( /* webpackChunkName: "comms_email-statuses" */ './views/app/comms/EmailStatusDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-templates',
      name: 'comms_email-templates-list',
      component: () => import( /* webpackChunkName: "comms_email-templates" */ './views/app/comms/EmailTemplateList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/email-templates/detail/:id',
      name: 'comms_email-templates-detail',
      component: () => import( /* webpackChunkName: "comms_email-templates" */ './views/app/comms/EmailTemplateDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/queued-emails',
      name: 'comms_queued-emails-list',
      component: () => import( /* webpackChunkName: "comms_queued-emails" */ './views/app/comms/QueuedEmailList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/queued-emails/detail/:id',
      name: 'comms_queued-emails-detail',
      component: () => import( /* webpackChunkName: "comms_queued-emails" */ './views/app/comms/QueuedEmailDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/smtp-connections',
      name: 'comms_smtp-connections-list',
      component: () => import( /* webpackChunkName: "comms_smtp-connections" */ './views/app/comms/SmtpConnectionList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/comms/smtp-connections/detail/:id',
      name: 'comms_smtp-connections-detail',
      component: () => import( /* webpackChunkName: "comms_smtp-connections" */ './views/app/comms/SmtpConnectionDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/custom/custom-field-configs',
      name: 'custom_custom-field-configs-list',
      component: () => import( /* webpackChunkName: "custom_custom-field-configs" */ './views/app/custom/CustomFieldConfigList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/custom/custom-field-configs/detail/:id',
      name: 'custom_custom-field-configs-detail',
      component: () => import( /* webpackChunkName: "custom_custom-field-configs" */ './views/app/custom/CustomFieldConfigDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/reporting/report-definitions',
      name: 'reporting_report-definitions-list',
      component: () => import( /* webpackChunkName: "reporting_report-definitions" */ './views/app/reporting/ReportDefinitionList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/reporting/report-definitions/detail/:id',
      name: 'reporting_report-definitions-detail',
      component: () => import( /* webpackChunkName: "reporting_report-definitions" */ './views/app/reporting/ReportDefinitionDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/application-files',
      name: 'system_application-files-list',
      component: () => import( /* webpackChunkName: "system_application-files" */ './views/app/system/ApplicationFileList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/application-files/detail/:id',
      name: 'system_application-files-detail',
      component: () => import( /* webpackChunkName: "system_application-files" */ './views/app/system/ApplicationFileDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/dashboards',
      name: 'system_dashboards-list',
      component: () => import( /* webpackChunkName: "system_dashboards" */ './views/app/system/DashboardList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/dashboards/detail/:id',
      name: 'system_dashboards-detail',
      component: () => import( /* webpackChunkName: "system_dashboards" */ './views/app/system/DashboardDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/dashboard-modules',
      name: 'system_dashboard-modules-list',
      component: () => import( /* webpackChunkName: "system_dashboard-modules" */ './views/app/system/DashboardModuleList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/dashboard-modules/detail/:id',
      name: 'system_dashboard-modules-detail',
      component: () => import( /* webpackChunkName: "system_dashboard-modules" */ './views/app/system/DashboardModuleDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/dashboard-module-types',
      name: 'system_dashboard-module-types-list',
      component: () => import( /* webpackChunkName: "system_dashboard-module-types" */ './views/app/system/DashboardModuleTypeList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/dashboard-module-types/detail/:id',
      name: 'system_dashboard-module-types-detail',
      component: () => import( /* webpackChunkName: "system_dashboard-module-types" */ './views/app/system/DashboardModuleTypeDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/data-retention-policies',
      name: 'system_data-retention-policies-list',
      component: () => import( /* webpackChunkName: "system_data-retention-policies" */ './views/app/system/DataRetentionPolicyList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/data-retention-policies/detail/:id',
      name: 'system_data-retention-policies-detail',
      component: () => import( /* webpackChunkName: "system_data-retention-policies" */ './views/app/system/DataRetentionPolicyDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/external-links',
      name: 'system_external-links-list',
      component: () => import( /* webpackChunkName: "system_external-links" */ './views/app/system/ExternalLinkList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/external-links/detail/:id',
      name: 'system_external-links-detail',
      component: () => import( /* webpackChunkName: "system_external-links" */ './views/app/system/ExternalLinkDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/history-types',
      name: 'system_history-types-list',
      component: () => import( /* webpackChunkName: "system_history-types" */ './views/app/system/HistoryTypeList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/history-types/detail/:id',
      name: 'system_history-types-detail',
      component: () => import( /* webpackChunkName: "system_history-types" */ './views/app/system/HistoryTypeDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/linkers',
      name: 'system_linkers-list',
      component: () => import( /* webpackChunkName: "system_linkers" */ './views/app/system/LinkerList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/linkers/detail/:id',
      name: 'system_linkers-detail',
      component: () => import( /* webpackChunkName: "system_linkers" */ './views/app/system/LinkerDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/logging-options',
      name: 'system_logging-options-list',
      component: () => import( /* webpackChunkName: "system_logging-options" */ './views/app/system/LoggingOptionList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/logging-options/detail/:id',
      name: 'system_logging-options-detail',
      component: () => import( /* webpackChunkName: "system_logging-options" */ './views/app/system/LoggingOptionDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/logos',
      name: 'system_logos-list',
      component: () => import( /* webpackChunkName: "system_logos" */ './views/app/system/LogoList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/logos/detail/:id',
      name: 'system_logos-detail',
      component: () => import( /* webpackChunkName: "system_logos" */ './views/app/system/LogoDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/queues',
      name: 'system_queues-list',
      component: () => import( /* webpackChunkName: "system_queues" */ './views/app/system/QueueList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/queues/detail/:id',
      name: 'system_queues-detail',
      component: () => import( /* webpackChunkName: "system_queues" */ './views/app/system/QueueDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/recurrence-types',
      name: 'system_recurrence-types-list',
      component: () => import( /* webpackChunkName: "system_recurrence-types" */ './views/app/system/RecurrenceTypeList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/recurrence-types/detail/:id',
      name: 'system_recurrence-types-detail',
      component: () => import( /* webpackChunkName: "system_recurrence-types" */ './views/app/system/RecurrenceTypeDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/rules',
      name: 'system_rules-list',
      component: () => import( /* webpackChunkName: "system_rules" */ './views/app/system/RuleList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/rules/detail/:id',
      name: 'system_rules-detail',
      component: () => import( /* webpackChunkName: "system_rules" */ './views/app/system/RuleDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/startup-controllers',
      name: 'system_startup-controllers-list',
      component: () => import( /* webpackChunkName: "system_startup-controllers" */ './views/app/system/StartupControllerList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/startup-controllers/detail/:id',
      name: 'system_startup-controllers-detail',
      component: () => import( /* webpackChunkName: "system_startup-controllers" */ './views/app/system/StartupControllerDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/storage-connections',
      name: 'system_storage-connections-list',
      component: () => import( /* webpackChunkName: "system_storage-connections" */ './views/app/system/StorageConnectionList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/storage-connections/detail/:id',
      name: 'system_storage-connections-detail',
      component: () => import( /* webpackChunkName: "system_storage-connections" */ './views/app/system/StorageConnectionDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/storage-connection-types',
      name: 'system_storage-connection-types-list',
      component: () => import( /* webpackChunkName: "system_storage-connection-types" */ './views/app/system/StorageConnectionTypeList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/storage-connection-types/detail/:id',
      name: 'system_storage-connection-types-detail',
      component: () => import( /* webpackChunkName: "system_storage-connection-types" */ './views/app/system/StorageConnectionTypeDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/string-templates',
      name: 'system_string-templates-list',
      component: () => import( /* webpackChunkName: "system_string-templates" */ './views/app/system/StringTemplateList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/string-templates/detail/:id',
      name: 'system_string-templates-detail',
      component: () => import( /* webpackChunkName: "system_string-templates" */ './views/app/system/StringTemplateDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/subscriptions',
      name: 'system_subscriptions-list',
      component: () => import( /* webpackChunkName: "system_subscriptions" */ './views/app/system/SubscriptionList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/subscriptions/detail/:id',
      name: 'system_subscriptions-detail',
      component: () => import( /* webpackChunkName: "system_subscriptions" */ './views/app/system/SubscriptionDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/sys-logs',
      name: 'system_sys-logs-list',
      component: () => import( /* webpackChunkName: "system_sys-logs" */ './views/app/system/SysLogList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/system/sys-logs/detail/:id',
      name: 'system_sys-logs-detail',
      component: () => import( /* webpackChunkName: "system_sys-logs" */ './views/app/system/SysLogDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/groups',
      name: 'uac_groups-list',
      component: () => import( /* webpackChunkName: "uac_groups" */ './views/app/uac/GroupList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/groups/detail/:id',
      name: 'uac_groups-detail',
      component: () => import( /* webpackChunkName: "uac_groups" */ './views/app/uac/GroupDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/invites',
      name: 'uac_invites-list',
      component: () => import( /* webpackChunkName: "uac_invites" */ './views/app/uac/InviteList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/invites/detail/:id',
      name: 'uac_invites-detail',
      component: () => import( /* webpackChunkName: "uac_invites" */ './views/app/uac/InviteDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/registrations',
      name: 'uac_registrations-list',
      component: () => import( /* webpackChunkName: "uac_registrations" */ './views/app/uac/RegistrationList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/registrations/detail/:id',
      name: 'uac_registrations-detail',
      component: () => import( /* webpackChunkName: "uac_registrations" */ './views/app/uac/RegistrationDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/sign-ins',
      name: 'uac_sign-ins-list',
      component: () => import( /* webpackChunkName: "uac_sign-ins" */ './views/app/uac/SignInList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/sign-ins/detail/:id',
      name: 'uac_sign-ins-detail',
      component: () => import( /* webpackChunkName: "uac_sign-ins" */ './views/app/uac/SignInDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/user-avatars',
      name: 'uac_user-avatars-list',
      component: () => import( /* webpackChunkName: "uac_user-avatars" */ './views/app/uac/UserAvatarList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/user-avatars/detail/:id',
      name: 'uac_user-avatars-detail',
      component: () => import( /* webpackChunkName: "uac_user-avatars" */ './views/app/uac/UserAvatarDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/user-prefs',
      name: 'uac_user-prefs-list',
      component: () => import( /* webpackChunkName: "uac_user-prefs" */ './views/app/uac/UserPrefList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/user-prefs/detail/:id',
      name: 'uac_user-prefs-detail',
      component: () => import( /* webpackChunkName: "uac_user-prefs" */ './views/app/uac/UserPrefDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/user-types',
      name: 'uac_user-types-list',
      component: () => import( /* webpackChunkName: "uac_user-types" */ './views/app/uac/UserTypeList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/uac/user-types/detail/:id',
      name: 'uac_user-types-detail',
      component: () => import( /* webpackChunkName: "uac_user-types" */ './views/app/uac/UserTypeDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/board/time-logs',
      name: 'board_time-logs-list',
      component: () => import( /* webpackChunkName: "board_time-logs" */ './views/app/board/TimeLogList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/board/time-logs/detail/:id',
      name: 'board_time-logs-detail',
      component: () => import( /* webpackChunkName: "board_time-logs" */ './views/app/board/TimeLogDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/dist/locations',
      name: 'dist_locations-list',
      component: () => import( /* webpackChunkName: "dist_locations" */ './views/app/dist/LocationList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/dist/locations/detail/:id',
      name: 'dist_locations-detail',
      component: () => import( /* webpackChunkName: "dist_locations" */ './views/app/dist/LocationDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/dist/distributions',
      name: 'dist_distributions-list',
      component: () => import( /* webpackChunkName: "dist_distributions" */ './views/app/dist/DistributionList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/dist/distributions/detail/:id',
      name: 'dist_distributions-detail',
      component: () => import( /* webpackChunkName: "dist_distributions" */ './views/app/dist/DistributionDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/schools',
      name: 'people_schools-list',
      component: () => import( /* webpackChunkName: "people_schools" */ './views/app/people/SchoolList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/schools/detail/:id',
      name: 'people_schools-detail',
      component: () => import( /* webpackChunkName: "people_schools" */ './views/app/people/SchoolDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/children',
      name: 'people_children-list',
      component: () => import( /* webpackChunkName: "people_children" */ './views/app/people/ChildList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/children/detail/:id',
      name: 'people_children-detail',
      component: () => import( /* webpackChunkName: "people_children" */ './views/app/people/ChildDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/clients',
      name: 'people_clients-list',
      component: () => import( /* webpackChunkName: "people_clients" */ './views/app/people/ClientList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/clients/detail/:id',
      name: 'people_clients-detail',
      component: () => import( /* webpackChunkName: "people_clients" */ './views/app/people/ClientDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/check-ins',
      name: 'people_check-ins-list',
      component: () => import( /* webpackChunkName: "people_check-ins" */ './views/app/people/CheckInList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/check-ins/detail/:id',
      name: 'people_check-ins-detail',
      component: () => import( /* webpackChunkName: "people_check-ins" */ './views/app/people/CheckInDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/enrollments',
      name: 'people_enrollments-list',
      component: () => import( /* webpackChunkName: "people_enrollments" */ './views/app/people/EnrollmentList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/enrollments/detail/:id',
      name: 'people_enrollments-detail',
      component: () => import( /* webpackChunkName: "people_enrollments" */ './views/app/people/EnrollmentDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/mappers',
      name: 'people_mappers-list',
      component: () => import( /* webpackChunkName: "people_mappers" */ './views/app/people/MapperList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/mappers/detail/:id',
      name: 'people_mappers-detail',
      component: () => import( /* webpackChunkName: "people_mappers" */ './views/app/people/MapperDetail.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/pre-maps',
      name: 'people_pre-maps-list',
      component: () => import( /* webpackChunkName: "people_pre-maps" */ './views/app/people/PreMapList.vue')
    },
    {
      beforeEnter: guard,
      path:'/app/people/pre-maps/detail/:id',
      name: 'people_pre-maps-detail',
      component: () => import( /* webpackChunkName: "people_pre-maps" */ './views/app/people/PreMapDetail.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})